import "./color.scss";

import * as React from "react";

export const Colors = ({colorsTileConfig}) => ({
    label: "Colors",
    render: () => <div className="horizontal-colors-1kl">{colorsTileConfig?.render()}</div>,
});
